module.exports = __webpack_public_path__ + "static/media/icon_error.b984869f.svg";